import { HTTP } from "./http";
let API_SERVER = "";
if (window.location.href.indexOf("8080") > -1) {
  API_SERVER = "http://www.localhost:8888/back-end-endpoint-teams.php";
} else {
  API_SERVER = "/personal-training-BE/back-end-endpoint-teams.php";
}

const Teams = {
  find(params) {
    return HTTP.post(API_SERVER, params);
  },

  show(id) {
    return HTTP.get(`users/${id}`);
  },

  store(post) {
    return HTTP.post("users", post);
  },

  update(post, id) {
    return HTTP.put(`users/${id}`, post);
  },

  delete(id) {
    return HTTP.delete(`users/${id}`);
  },

  getTeamsByUserId(userId) {
    return this.find({
      action: "getUserCreatedTeams",
      userId: userId,
    });
  },

  getTeamById(teamId) {
    return this.find({
      action: "getUserTeamById",
      id: teamId,
    });
  },

  createTeam(teamData) {
    return this.find({
      action: "createUserTeam",
      ...teamData,
    });
  },

  updateTeam(teamData) {
    return this.find({
      action: "updateUserTeam",
      ...teamData,
    });
  },

  deleteTeam(teamId) {
    return this.find({
      action: "deleteUserTeam",
      teamId: teamId,
    });
  },

  getTeamsWithSeasonOverrides(clubId) {
    return this.find({
      action: "getTeamsWithSeasonOverrides",
      clubId: clubId,
    });
  },

  setTeamSeasonOverride(teamId, startDate, endDate, callerId) {
    return this.find({
      action: "setTeamSeasonOverride",
      teamId: teamId,
      season_start_date: startDate,
      season_end_date: endDate,
      caller_id: callerId,
    });
  },

  clearTeamSeasonOverride(teamId, callerId) {
    return this.find({
      action: "clearTeamSeasonOverride",
      teamId: teamId,
      caller_id: callerId,
    });
  },

  clearAllTeamSeasonOverrides(clubId, callerId) {
    return this.find({
      action: "clearAllTeamSeasonOverrides",
      clubId: clubId,
      caller_id: callerId,
    });
  },
};

export { Teams };
